<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div
            class="w-100 mb-3 d-flex align-items-center justify-content-between"
          >
            <h1>جزئیات منابع درآمد (تومان)</h1>
          </div>
          <filters-wrapper @submitFilters="setFilters">
            <range-date-picker
              class="w-24 filters-width"
              label="بازه‌ی تاریخ منابع درآمد را وارد کنید"
              @getDateRange="setDateRange"
            ></range-date-picker>
            <!-- fromUserFullanme -->
            <search-input
              :inputValue="incomeOutcomeCashFilters.fromUserFullanme"
              inputLabel="جستجو بر اساس نام زبان آموز"
              inputPlaceholder="امیر..."
              v-model="incomeOutcomeCashFilters.fromUserFullanme"
              @enter="setFilters"
            ></search-input>
            <!-- fromUserMobile -->
            <search-input
              :inputValue="incomeOutcomeCashFilters.fromUserMobile"
              inputLabel="جستجو بر اساس شماره همراه زبان آموز"
              inputPlaceholder="0912..."
              v-model="incomeOutcomeCashFilters.fromUserMobile"
              @enter="setFilters"
            ></search-input>
            <price-category-picker
              @getPriceCategory="setPriceCategory"
              class="w-24 filters-width"
            ></price-category-picker>
            <user-picker
              class="w-24 filters-width"
              @getUser="setUserIdFilter"
            ></user-picker>
            <chart-types-dropdown
              @getChartType="setChartType"
              class="w-24 filters-width"
            ></chart-types-dropdown>
            <LanguagePicker
              placeHolder="نمایش بر اساس زبان"
              @getLanguage="setChartLanguage"
              class="w-24 filters-width"
            ></LanguagePicker>
          </filters-wrapper>

          <div class="my-2">
            <!-- Table Top Start -->
            <b-row>
              <b-col cols="12">
                <general-pie-chart
                  ref="chart"
                  :getChartData="getIncomeOutcomeChartData"
                >
                </general-pie-chart>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      incomeOutcomeCashFilters: {
        pageNumber: 1,
        count: 50,
        type: null,
        fromDate: null,
        toDate: null,
        fromUserFullanme: null,
        fromUserMobile: null,
        toUserFullanme: null,
        toUserMobile: null,
        courseId: null,
        lessonId: null,
        fromUserId: null,
        toUserId: null,
        priceCategoryId: null,
        description: null,
        orderId: null,
        vipUserId: null,
        price: null,
        languageId: null,
      },
    };
  },
  methods: {
    setChartLanguage(languageId) {
      this.incomeOutcomeCashFilters.languageId = languageId;
    },
    setFilters() {
      this.$refs?.chart?.sendChartRequest();
    },
    setChartType(chartType) {
      this.incomeOutcomeCashFilters.type = chartType;
    },
    setUserIdFilter(userId) {
      this.incomeOutcomeCashFilters.fromUserId = userId;
    },
    setPriceCategory(priceCategoryId) {
      this.incomeOutcomeCashFilters.priceCategoryId = priceCategoryId;
    },
    setDateRange(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.incomeOutcomeCashFilters.fromDate = new Date(
          dateRange[0]
        ).toISOString();
        this.incomeOutcomeCashFilters.toDate = new Date(
          dateRange[1]
        ).toISOString();
      } else {
        this.incomeOutcomeCashFilters.fromDate = null;
        this.incomeOutcomeCashFilters.toDate = null;
      }
    },
    async getIncomeOutcomeChartData(_this) {
      this.isLoading = true;
      let that = this;
      try {
        let getIncomeOutcomeChart = new GetIncomeOutcomeChart(_this);
        getIncomeOutcomeChart.setRequestParamDataObj(
          that.incomeOutcomeCashFilters
        );
        await getIncomeOutcomeChart.fetch((res) => {
          _this.chartOptions.labels = [];
          _this.chartOptions.series = [];
          if (res.length > 0) {
            res.forEach((item) => {
              _this.chartOptions.labels.push(item.title);
              _this.chartOptions.series.push(item.value);
            });
            _this.chartOptions.dataLabels["formatter"] = function (val, opts) {
              return `${Intl.NumberFormat("en-US").format(
                +opts["w"]["globals"]["series"][opts["seriesIndex"]]
              )} تومان`;
            };
            _this.chartOptions["tooltip"]["y"] = {
              formatter: (value) =>
                `${Intl.NumberFormat("en-US").format(+value)} تومان`,
            };
            _this.isRenderingChart = true;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BOverlay,
    FiltersWrapper,
    SearchInput,
    RangeDatePicker,
    GeneralPieChart,
    PriceCategoryPicker,
    UserPicker,
    ChartTypesDropdown,
    LanguagePicker,
  },
};
import { GetIncomeOutcomeChart } from "@/libs/Api/IncomeOutcomeTransaction";
import { BCard, BRow, BCol, BOverlay } from "bootstrap-vue";
import FiltersWrapper from "@/views/components/Utils/FiltersWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";
import GeneralPieChart from "@/views/dashboard/analytics/IncomeOutcome/GeneralPieChart.vue";
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import UserPicker from "@/views/components/Users/UserPicker.vue";
import ChartTypesDropdown from "@/views/components/Utils/ChartTypesDropdown.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
</script>
